<template>
  <div>
    <el-table :data="items">
      <el-table-column
        align="center"
        label="复合片"
        prop="pdc.name"
      ></el-table-column>
      <el-table-column align="center" label="新 / 旧">
        <template slot-scope="scope">
          {{ scope.row.category == 1 ? '新齿' : '旧齿' }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="供应方"
        prop="supplier"
      ></el-table-column>
      <el-table-column
        align="center"
        label="到货日期"
        prop="arrive_date"
        min-width="100"
      ></el-table-column>
      <el-table-column
        align="center"
        label="到货批次"
        prop="arrive_batch"
      ></el-table-column>
      <!-- <el-table-column
        align="center"
        label="税率"
        prop="tax_rate"
      ></el-table-column>
      <el-table-column
        align="center"
        label="含税价格"
        prop="price"
      ></el-table-column> -->
      <el-table-column
        align="center"
        label="数量"
        prop="number"
      ></el-table-column>
      <el-table-column
        align="center"
        label="剩余"
        prop="left_number"
      ></el-table-column>
      <el-table-column align="center" label="状态">
        <template slot-scope="scope">
          <span
            class="label"
            :class="scope.row.status == 1 ? 'label-warning' : 'label-success'"
          >
            {{ scope.row.status == 1 ? '未入库' : '已入库' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="入库时间" align="center" min-width="120">
        <template slot-scope="scope">
          {{
            scope.row.confirm_time
              ? $time(scope.row.confirm_time).format('YYYY-MM-DD')
              : '-'
          }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="120" v-if="admin">
        <template slot-scope="scope">
          <template v-if="scope.row.status == 1">
            <btn-tag
              :btn="true"
              text="编辑"
              :key="Math.random()"
              :auth-id="51201"
              module-name="stock"
              @click.native="editItem(scope.row, scope.$index)"
            ></btn-tag>
            <btn-tag
              :btn="true"
              text="删除"
              :key="Math.random()"
              :auth-id="51201"
              module-name="stock"
              btn-class="btn-danger"
              @click.native="hanldeDelte(scope.row, scope.$index)"
            ></btn-tag>
            <btn-tag
              :btn="true"
              text="确认入库"
              :key="Math.random()"
              :auth-id="51201"
              module-name="stock"
              btn-class="btn-warning"
              @click.native="hanldeConfirmStockIn(scope.row, scope.$index)"
            ></btn-tag>
          </template>
          <template v-else>-</template>
        </template>
      </el-table-column>
    </el-table>
    <pdc-in-former
      :model="model"
      :show.sync="formerVisible"
      @updated="updatedCallback"
    ></pdc-in-former>
  </div>
</template>

<script>
import { pdcInRecordDelete, pdcInRecordConfirm } from '@/service/getData'
import PdcInFormer from '@/components/pdc_in_former'
import { deepClone } from '@/utils'

export default {
  components: {
    PdcInFormer,
  },
  props: {
    items: null,
    admin: false,
  },
  data() {
    return {
      model: {},
      formerVisible: false,
      editIndex: 0,
    }
  },
  methods: {
    hanldeDelte(item, index) {
      let that = this
      that.$dialog.confirm('确认删除吗').then(function (dialog) {
        pdcInRecordDelete(item.id).then((res) => {
          if (res.status == 0) {
            that.items.splice(index, 1)
          }
        })
      })
    },

    editItem(item, index) {
      this.model = deepClone(item)
      this.editIndex = index
      this.formerVisible = true
    },
    updatedCallback(data) {
      this.$set(this.items, this.editIndex, data)
    },

    hanldeConfirmStockIn(item, index) {
      let that = this
      this.$confirm('确认入库吗?', '操作提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          let res = await pdcInRecordConfirm(item.id)
          if (res.status == 0) {
            that.$set(that.items, index, res.data)
          }
        })
        .catch(() => {})
    },
  },
}
</script>